<!--
/*******************************************************************************
*@ 컴포넌트명   : PeriodInq.vue
*@ 컴포넌트설명 : 거래내역 기간별 조회
*@ 사용전문     : RBF0404A40 - 예금계좌거래내역조회 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <account-search-box
      ref="searchBox"
      in-acn-knd="0"
      in-acn-dtl-knd="0"
      :show-option="['acno', 'calRange', 'inotDstcd', 'resultSeq']"
      :range-option="[
        this.$config.CALENDAR_RANGE_TODAY,
        this.$config.CALENDAR_RANGE_1W,
        this.$config.CALENDAR_RANGE_1M,
        this.$config.CALENDAR_RANGE_3M,
        this.$config.CALENDAR_RANGE_6M,
        this.$config.CALENDAR_RANGE_12M,
      ]"
      :default-range-index="$route.params.rangeIndex != undefined ? $route.params.rangeIndex : $config.CALENDAR_RANGE_1M"
      :default-acno="initAcno"
      @search="firstCall"
    >
      <template #tag>
        <search-tag v-for="(data, i) of tagList" :key="i" :index="i" :text="$t(data)" @remove="remove" />
      </template>
    </account-search-box>
    <common-grid2 ref="commonGrid2" :list="dpstAcnGrid" :show-search-bar="true" :scroll-event="true" v-show="showGrid" @reSearch="scrollResearch">
      <template v-slot:list="data">
        <div class="item date">{{ $getGlobalDateFmt(data.row.tranYms) }}</div>
        <template v-if="data.row.inotBasiSumryCd == '041' || data.row.inotBasiSumryCd == '042' || data.row.inotBasiSumryCd == '044' || data.row.inotBasiSumryCd == '046'">
          <div class="item use link" @click="tagPush(`${data.row.inotBasiSumryCd}_입출근거적요코드`, 'code', data.row.inotBasiSumryCd)">
            <div class="link"># {{ $t(`${data.row.inotBasiSumryCd}_입출근거적요코드`) }}</div>
          </div>
        </template>
        <template v-else>
          <div class="item use">{{ $t(`${data.row.inotBasiSumryCd}_입출근거적요코드`) }}</div>
        </template>
        <div class="item name">{{ data.row.rmtancDrawe }}</div>
        <div class="item object" :class="data.row.brncoInotDstcd == 10 ? 'deposit' : 'withdraw'">
          <template v-if="data.row.mnrcvAmt != '0'">
            <div class="tit">{{ /*입금 금액*/ $t("MINQ-02-01-01-07") }}</div>
            <div class="desc">
              <span class="exchange-unit">{{ data.row.cncycd }}</span>
              <span class="amount" @click="tagPush(data.row.mnrcvAmt, 'amt', data.row.mnrcvAmt)" v-html="$num(data.row.mnrcvAmt, null, true)"></span>
            </div>
          </template>
          <template v-else>
            <div class="tit">{{ /*출금 금액*/ $t("MINQ-02-01-01-12") }}</div>
            <div class="desc">
              <span class="exchange-unit">{{ data.row.cncycd }}</span>
              <span class="amount" @click="tagPush(data.row.drwotAmt, 'amt', data.row.drwotAmt)" v-html="$num(data.row.drwotAmt, null, true)"></span>
            </div>
          </template>
        </div>
        <div class="item balance">
          <div class="tit">{{ /*계좌 잔액*/ $t("MINQ-02-01-01-13") }}</div>
          <div class="desc">
            <span class="exchange-unit">{{ data.row.cncycd }}</span>
            <span class="amount" v-html="$num(data.row.tranAfBal, null, true)"></span>
          </div>
        </div>
        <template v-if="data.row.brncoInotDstcd == '10'">
          <template v-if="data.row.inotBasiSumryCd == '015' || data.row.inotBasiSumryCd == '016'">
            <div class="tit">{{ /*수표번호*/ $t("MINQ-02-01-05-14") }}</div>
            <div class="desc" @click="tagPush(data.row.chekNo, 'memo', data.row.chekNo)">{{ data.row.rmark }}</div>
          </template>
          <template v-else>
            <template v-if="data.row.rmark != ''">
              <div class="item etc">
                <div class="tit">{{ /*적요*/ $t("MINQ-02-01-04-09") }}</div>
                <div class="desc">{{ data.row.rmark }}</div>
              </div>
            </template>
          </template>
        </template>
        <template v-else>
          <template v-if="data.row.inotBasiSumryCd == '092' && data.row.rmark != ''">
            <div class="item etc">
              <div class="tit">{{ /*송금메모*/ $t("MINQ-02-01-06-09") }}</div>
              <div class="desc" @click="tagPush(data.row.rmark, 'memo', data.row.rmark)">{{ data.row.rmark }}</div>
            </div>
          </template>
          <template v-else-if="data.row.inotBasiSumryCd == '042'">
            <div class="item etc">
              <div class="tit">{{ $t(/*대출계좌번호*/ "MINQ-02-01-06-14") }}</div>
              <div class="desc" @click="tagPush(data.row.rmark, 'memo', data.row.rmark)">{{ data.row.rmark }}</div>
            </div>
          </template>
          <template v-else-if="data.row.inotBasiSumryCd == '044'">
            <div class="item etc">
              <div class="tit">{{ $t(/*대출계좌번호*/ "MINQ-02-01-06-14") }}</div>
              <div class="desc" @click="tagPush(data.row.rmark, 'memo', data.row.rmark)">{{ data.row.rmark }}</div>
            </div>
          </template>
          <template v-else>
            <template v-if="data.row.rmark != ''">
              <div class="item etc">
                <div class="tit">{{ /*송금목적*/ $t("PCOP-02-03-05-24") }}</div>
                <div
                  class="desc"
                  @click="tagPush(data.row.rmark, 'memo', data.row.rmark)"
                  v-if="data.row.rmark.includes(':') && /^[A-Z0-9]{1}[0-9]{1}$/.test(data.row.rmark.split(':', 1))"
                >
                  {{ $t(`${data.row.rmark.split(":", 1)}_송금목적구분_MMR2`) /* 송금목적구분_MMR2: 타행이체신청내역조회(_MMR: 인뱅기준/_MMR2: 단말기준) */ }}
                </div>
                <div class="desc" @click="tagPush(data.row.rmark, 'memo', data.row.rmark)" v-else>{{ data.row.rmark }}</div>
              </div>
            </template>
          </template>
        </template>
        <!-- <div class="item etc">
          <div class="tit" v-if="data.row.brncoInotDstcd == 10">적요</div>
          <div class="tit" v-else>{{ /*송금메모*/ $t("0001-049") }}</div>
          <div
            class="desc"
            @click="tagPush(data.row.rmark, 'memo', data.row.rmark)"
          >{{ data.row.rmark }}</div>
        </div>-->
      </template>
    </common-grid2>
  </article>
</template>
<script>
import AccountSearchBox from "@/components/page/common/AccountSearchBox";
import CommonGrid2 from "@/components/page/common/CommonGrid2";
import SearchTag from "@/components/template/SearchTag";
import { mapFields } from "vuex-map-fields";
export default {
  components: {
    AccountSearchBox,
    CommonGrid2,
    SearchTag,
  },
  computed: {
    ...mapFields("accounts", ["initAcno"]),
  },
  mounted() {
    if (!_.isEmpty(this.$route.params)) {
      if (!_.isNil(this.$route.params.acno) && !_.isEmpty(this.$route.params.acno)) {
        this.initAcno = this.$route.params;
      } else {
        this.initAcno = this.$route.params.acno;
      }
      this.$refs.searchBox.search();
    }
  },
  data() {
    return {
      RBF0404A40: {},
      requestData: {},
      tagList: [],
      searchData: {},
      showGrid: false,
      page: 1,
      showSearchRange: false,
      //태그 추가 여부
      code: false,
      amt: false,
      memo: false,
      //태그 idx
      codeIndex: "",
      amtIndex: "",
      memoIndex: "",
      //initem field
      tranAmt: "",
      serchWord: "",
      inotBasiSumryCd: "",
      call: true,
      dpstAcnGrid: [],
      addSearch: false,
      totalLineCnt: 0,
      searchType: "searchBox",
    };
  },
  methods: {
    firstCall(srchParam, acnoParam, type) {
      this.initAcno = acnoParam;
      if (acnoParam.acnoKnd2 == "3") {
        //입출금 거래내역조회
        this.page = 1;
        this.showSearchRange = false;
        this.searchData = { ...srchParam, ...acnoParam };
        this.RBF0404A40Call(type);
      } else {
        //1,2,3:예금 4:적금 5:대출
        if (acnoParam.acnDtailCd == "4") {
          //적금 거래내역조회
          this.$router.push({ name: "instypFxdepTrnhis" });
        } else if (acnoParam.acnDtailCd == "5") {
          //대출 거래내역조회
          this.$router.push({ name: "lnAcnTrnhis" });
        } else {
          //예금 거래내역조회
          this.$router.push({ name: "dfstlFxdepTrnhis" });
        }
      }
    },
    RBF0404A40Call(type) {
      if (this.call) {
        if (type == "tag" || type == "addSearch") {
          this.searchType = type;
          this.page = 1;
        } else if (type == "scroll") {
          this.searchType = type;
          this.page++;
        } else {
          this.searchType = "searchBox";
          this.page = 1;
        }
        this.call = false;
        this.showGrid = true;
        this.requestData = {
          ...this.searchData,
          inotBasiSumryCd: this.inotBasiSumryCd, //적요코드
          serchWord: this.serchWord, //검색단어
          tranAmt: this.tranAmt, //거래금액
          dmndPageNo: this.page, //요청페이지번호
          pageLineCnt: 10, //페이지라인수
        };
        this.$post("/account/trnhis/OndmdTrnhis", this.requestData, this.RBF0404A40Suc, null, this.RBF0404A40Final);
      }
    },
    RBF0404A40Suc(res) {
      this.dpstAcnGrid = [];
      this.RBF0404A40 = {
        ...res.outItem,
      };

      if (!_.isEmpty(res.outItem.dpstAcnGrid)) {
        this.dpstAcnGrid = res.outItem.dpstAcnGrid;
      }
      this.totalLineCnt = this.RBF0404A40.totalLineCnt;
    },
    RBF0404A40Final() {
      this.$refs.commonGrid2.changeList(this.dpstAcnGrid, this.totalLineCnt, this.searchType);
      this.call = true;
      // }
    },
    //태그 삭제
    remove(i) {
      let lastIndex = i == this.tagList.length - 1 ? true : false;
      this.$log.info(`${i} 삭제`);
      this.tagList.splice(i, 1);
      switch (i) {
        case this.codeIndex:
          this.codeIndex = "";
          this.code = false;
          this.inotBasiSumryCd = "";
          this.RBF0404A40Call("tag");
          break;
        case this.amtIndex:
          this.amtIndex = "";
          this.amt = false;
          this.tranAmt = "";
          this.RBF0404A40Call("tag");
          break;
        case this.memoIndex:
          this.memoIndex = "";
          this.memo = false;
          this.serchWord = "";
          this.RBF0404A40Call("tag");
          break;
      }

      let listLength = this.tagList.length - 1;
      if (lastIndex == false) {
        if (listLength <= this.codeIndex && this.codeIndex != "") {
          this.codeIndex--;
        }
        if (listLength <= this.amtIndex && this.amtIndex != "") {
          this.amtIndex--;
        }
        if (listLength <= this.memoIndex && this.memoIndex != "") {
          this.memoIndex--;
        }
      }
    },
    //태그 푸쉬
    tagPush(text, type, value) {
      switch (type) {
        case "code":
          if (value == "041" || value == "042" || value == "044" || value == "046") {
            if (this.code) {
              this.$set(this.tagList, this.codeIndex, text);
              this.inotBasiSumryCd = value;
            } else {
              this.code = true;
              this.codeIndex = this.tagList.length;
              this.tagList.push(text);
              this.inotBasiSumryCd = value;
            }
            this.RBF0404A40Call("tag");
          } else {
            break;
          }
          break;
        case "amt":
          if (this.amt) {
            this.$set(this.tagList, this.amtIndex, this.$num(text));
            this.tranAmt = value;
          } else {
            this.amt = true;
            this.amtIndex = this.tagList.length;
            this.tagList.push(this.$num(text));
            this.tranAmt = value;
          }
          this.RBF0404A40Call("tag");
          break;
        case "memo":
          if (this.memo) {
            this.$set(this.tagList, this.memoIndex, text);
            this.serchWord = value;
          } else {
            this.memo = true;
            this.memoIndex = this.tagList.length;
            this.tagList.push(text);
            this.serchWord = value;
          }
          this.RBF0404A40Call("tag");
          break;
      }
    },
    scrollResearch() {
      this.RBF0404A40Call("scroll");
    },
  },
};
</script>
